import { Constants } from '../constants';
import { Core as Settings } from '@usercentrics/cmp-browser-sdk';

export const getLanguage = (settings?: Settings): string => {
  return settings?.language?.selected || document.documentElement.lang || Constants.DEFAULT_LANGUAGE_CODE;
};
